"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// NOTE: This migration is here as example. Could be removed when real migration added.
function migrateToV1(settingsV0) {
    return tslib_1.__assign(tslib_1.__assign({}, settingsV0), { settingsVersion: 1 });
}
exports.default = migrateToV1;
//# sourceMappingURL=migrateToV1.js.map